import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const useGetGastos = (filtros) => {
  const { getJwtToken } = useAuth();
  return useQuery({
    queryKey: ['gastos', filtros],
    queryFn: async () => {
      const token = await getJwtToken();
      const params = new URLSearchParams(filtros).toString();
      const res = await fetch(`${API_BASE_URL}/v1-gastos?${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Si el servidor falla, lanzamos el error para que React Query lo atrape
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Error al obtener gastos');
      }
      return res.json();
    }
  });
};

export const useGetCategoriasGastos = () => {
  const { getJwtToken } = useAuth();
  return useQuery({
    queryKey: ['categorias_gastos'],
    queryFn: async () => {
      const token = await getJwtToken();
      const res = await fetch(`${API_BASE_URL}/v1-gastos-categorias`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Error al obtener categorías');
      }
      return res.json();
    }
  });
};

// Hook Unificado para CREAR o EDITAR Categorías
export const useSaveCategoriaGasto = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();

  return useMutation({
    mutationFn: async (payload) => {
      const token = await getJwtToken();

      const esEdicion = !!payload.id;

      // 👇 AQUÍ ESTÁ LA MAGIA: Si es edición, le agregamos el ID a la URL
      const url = esEdicion
        ? `${API_BASE_URL}/v1-gastos-categorias/${payload.id}`
        : `${API_BASE_URL}/v1-gastos-categorias`;

      const res = await fetch(url, {
        method: esEdicion ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.error || 'Error al guardar categoría');
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categorias_gastos'] });
    }
  });
};

export const useSaveGasto = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();
  
  return useMutation({
    mutationFn: async (payload) => {
      const token = await getJwtToken();
      const esEdicion = !!payload.id;

      const url = esEdicion
        ? `${API_BASE_URL}/v1-gastos/${payload.id}`
        : `${API_BASE_URL}/v1-gastos`;

      const res = await fetch(url, {
        method: esEdicion ? "PUT" : "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
         const err = await res.json();
         throw new Error(err.error || 'Error al guardar gasto');
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gastos'] });
      queryClient.invalidateQueries({ queryKey: ['caja'] });
    }
  });
};

export const useDeleteGasto = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();
  
  return useMutation({
    mutationFn: async (id) => {
      const token = await getJwtToken();
      const res = await fetch(`${API_BASE_URL}/v1-gastos/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.ok) {
         const err = await res.json();
         throw new Error(err.error || 'Error al eliminar gasto');
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gastos'] });
      queryClient.invalidateQueries({ queryKey: ['caja'] });
    }
  });
};
